import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import axios from 'axios';
import $ from 'jquery';
import {
  Table
} from "react-bootstrap";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { baseUrl, apiUrl,mediaUrl} from '../Config/Config';
import QueryContext from '../QueryContext';
import moment from 'moment';
class List extends Component {
  static contextType = QueryContext;
  constructor(props)
  {
     super(props); 
      this.state = {
          doctorlist:'',
          editable: false,
          activePage: 1,
          totalRecord: '',
          search_all:'',
			    certificate_verified_checked:false
      };

      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);

    }

   
   componentDidMount() {

    var qs = require('qs');
    var postobject = {
    activePage: 1,
    search_all: '',
    admin_id: localStorage.getItem('admin_id')  
    };

    axios.post(apiUrl+"traveler/list",qs.stringify(postobject)).then(res => {
      if(res.data.status === 'success'){ 
          this.setState({  doctorlist: res.data.cliniclist, totalRecord: res.data.records_count}, function() {
            this.doctorlist();
          });

      }
    }); 
   }


  handlePageChange(pageNumber) {
   // console.log(`active page is ${pageNumber}`);
    this.setState({activePage: pageNumber});
    var qs = require('qs');
    var postobject = {
      activePage: pageNumber,
      search_all: this.state.search_all,
      admin_id: localStorage.getItem('admin_id')  
    };
    
    axios.post(apiUrl+"traveler/list",qs.stringify(postobject)).then(res => {
      if(res.data.status === 'success'){ 
          this.setState({  doctorlist: res.data.cliniclist, totalRecord: res.data.records_count}, function() {
            this.doctorlist();
          });

      }
    }); 

  }

  handleInputChange(event) {
  const {name, value} = event.target;      
  this.setState({
    [name]: value
  });
  if(name == 'certificate_verified'){
    this.setState({certificate_verified_checked:!this.state.certificate_verified_checked});
    alert(!this.state.certificate_verified_checked);
  }
  
}
 handleFormSubmit = () => {
      
        this.setState({Loading:true});
        var qs = require('qs');
        const formPayload = this.state;
         
        var postObject = {             
          activePage   : 1,
          search_all : formPayload.search_all,
          admin_id: localStorage.getItem('admin_id')           
        };
        //console.log(postObject);
        axios.post(apiUrl+"traveler/list",qs.stringify(postObject)).then(res => {
          if(res.data.status === 'success'){ 
              this.setState({  doctorlist: res.data.cliniclist, totalRecord: res.data.records_count}, function() {
                this.doctorlist();
              });    
          }else{
            this.setState({  doctorlist:'', totalRecord: ''}, function() {
              this.doctorlist();
            });    
          }        
        }); 
  } 

   componentWillReceiveProps(Props){
    
	
	if(Props.changestatus !== this.props.changestatus){
      if (Props.changestatus[0]["status"] === "success") {
            var qs = require('qs');
            var postobject = {
           activePage: this.state.activePage,
            search_all: '',
            admin_id : localStorage.getItem("admin_id")
            };
            this.props.getUserList(qs.stringify(postobject));
      }
    }
	
	
	if(Props.exportuser !== this.props.exportuser){
		
      if (Props.exportuser[0]["status"] === "success") {
		  let url =baseUrl+"/"+Props.exportuser[0]["message"];
          window.open(url,
  '_blank' // <- This is what makes it open in a new window.
);
      }
    }
   }

   deleteConfirm=(confirmstatus,id)=>{
    if(confirmstatus == 'yes'){
			$('.confirm-action-delete').removeClass('show');
      
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id
        };
        var curr = this;
        axios.post(apiUrl+"traveler/delete",qs.stringify(postObject)).then(res => {
          if(res.data.status === 'success'){
     
            $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');

              setTimeout(
              function() {
                $('.success_message').html('');
                window.location.reload(); 
              }
              .bind(this),
              3000
              );
          }
        }); 
      }else{
        $('.confirm-action-delete').removeClass('show');	
      }
   }

activateuser(id, status){
	let stat = ''
		if(status == 'Inactive'){
			stat = "A";
		}else{
			stat = "I";
		}
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id,
		      status: stat
        };
      axios.post(apiUrl+"traveler/change_status",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');

          setTimeout(
          function() {
            $('.success_message').html('');
          }
          .bind(this),
          3000
          );
          var qs = require('qs');
          var postobject = {
            activePage: 1,
            search_all: '',
            admin_id: localStorage.getItem('admin_id')  
          };
          axios.post(apiUrl+"traveler/list",qs.stringify(postobject)).then(res => {
            if(res.data.status === 'success'){
                this.setState({  doctorlist: res.data.cliniclist, totalRecord: res.data.records_count}, function() {
                  this.doctorlist();
                });
      
            }
          }); 
  
        }
      }); 
}
  verifieddoctor(id, Verification){
    let stat = ''
      if(Verification == 'checked'){
        stat = "No";
      }else{
        stat = "Yes";
      }
      var qs = require('qs');
      var postObject = {
        admin_id : localStorage.getItem("admin_id"),
        id  :id,
        status: stat
      };
      axios.post(apiUrl+"traveler/cerificate_verify",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');

          setTimeout(
          function() {
            $('.success_message').html('');
          }
          .bind(this),
          3000
          );
          var qs = require('qs');
          var postobject = {
            activePage: 1,
            search_all: '',
            admin_id: localStorage.getItem('admin_id')  
          };
          axios.post(apiUrl+"traveler/list",qs.stringify(postobject)).then(res => {
            if(res.data.status === 'success'){
                this.setState({  doctorlist: res.data.cliniclist, totalRecord: res.data.records_count}, function() {
                  this.doctorlist();
                });      
            }
          });   
        }
      }); 
  }

exportdata(){
	let stat = '';		
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id")
        };
      this.props.getExportUser(qs.stringify(postObject));
}
 doctorlist(ehrpanel) {
  var doctorlist = this.state.doctorlist;
  if (doctorlist != "undefined" && doctorlist != null) {
    if (Object.keys(doctorlist).length > 0) {
      const doctorlistDetails = doctorlist.map(
        (data, Index) => {
          // console.log(data,"data");
          
          let sno = Index+1;

          if(data.status == 'A'){
            var status = 'Active';
          }else{
              status = 'Inactive';
          }

          

          var mobileno = ((data.phone == null)||(data.phone == '') || (data.phone == 0)) ?  data.phone = 'N/A' : data.phone;
        
          if((data.certificate_verified) =='Yes'){
            var Verification = 'checked';
					}else{
            Verification = '';

					}

          return (
            <tr key={data.id}>
            <td>{sno}</td>
            <td>{ data.image!='' && data.image!=null&&data.image!=undefined&&<>
                    <img className="img_class"  width="100px" height="100px" src={mediaUrl+'/'+'clinic'+'/'+data.image} alt="" />  </>}</td>
              <td>
              {data.name}
              </td>
              <td>
              {data.username}
              </td>
              <td>{data.org_password}</td>
              {/* <td>{data.domain_name}</td> */}
              <td>{data.email}</td>
              <td>{mobileno}</td>
              <td>${data.cost}</td>
              <td>{moment(data.created_on).format('MMM/DD/Y hh:mm A')}</td>
              
              {/* <td>{data.cat_name}</td> */}
              {/* <td>{status}</td>  */}
            
              <td className="actiongroup">
                      {/* {(ehrpanel)? <Link to={{ pathname: '/travelerEMR/'+data.id+'?ehrpanel=true'}} className="" title="View">  <i className="ft-eye" aria-hidden="true"></i></Link>:
                             <> */}
                      <Link to={{ pathname: '/traveler-edit/'+data.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                      {(status == 'Active'?<Link onClick={this.activateuser.bind(this, data.id, status)} className="" title="Status"><i className="ft-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.activateuser.bind(this, data.id, status)} className="" title="Status"><i className="ft-lock" aria-hidden="true"></i></Link>)}  
                      <Link onClick={this.deletedata.bind(this,data.id)} className="" title="Delete"><i className="ft-trash-2" aria-hidden="true"></i></Link>  
                  {/* </>} */}

              </td>
            </tr>
          );
        }
      );
      return doctorlistDetails;
    } else {
    return (
      <tr>
        <td colSpan="10" className="v-align-nr text-center">
          No Result
        </td>
      </tr>
    );
  }
   }   
}


deletedata(id){
  this.setState({rowid : id})
  $('.confirm-action-delete-message').html('Are you sure delete the Clinic?');	
  $('.confirm-action-delete').addClass('show');	
 }
  
  render() {
    const { ehrpanel } = this.context;
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="traveler" />  

  
  <div className="content"> 
    <div className="content-wrapper">
      <div class="content-wrapper-before"></div>
      <div className="car-listing-wrap leaa-admin-head card">
      <div className="success_message"></div>
        <div className="listing-header"> 
          <div className="title">
            <h3>{this.state.totalRecord>0&&this.state.totalRecord} Traveler</h3>
          </div>
          <div className="search-list">
                <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                </form>
          </div> 
          {(ehrpanel)?<div className="add_button"></div>: <div className="add_button">  
      		 <a className="" href='/traveler-add'>Add</a>
			     {/* <a className="" href='/user-import'>Import <i className="import-icon icon" aria-hidden="true"></i> &nbsp;|&nbsp;</a>
           <Link onClick={this.exportdata.bind(this)} className="" title="Export"> Export <i className="ft-upload" aria-hidden="true"></i></Link>*/}
          </div>}
        </div>

        <div className="car-listing-row">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Image</th>
                <th>Clinic</th>
			          <th>Username</th>
                <th>Password</th>
                {/* <th>Domain</th> */}
                <th>Email</th>
				        <th>Contact</th>
                {/* <th>Specialist</th> */}
                {/* <th>Status</th> */}
                <th>Booking Fee</th>  
                <th>Created On</th>  
                <th>Action</th>
              </tr>
            </thead>
            <tbody>{this.doctorlist(ehrpanel)}</tbody>
          </Table>
          <div className="text-center">
            <Pagination
            activePage={this.state.activePage}
            itemsCountPerPage={10}
            totalItemsCount={this.state.totalRecord}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange.bind(this)}
            />
          </div>
        </div>
                      
      </div>  
    </div>  
  </div>
      
  <div className="confirm-action-delete">
								<p className="confirm-action-delete-message"></p>
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.rowid)} className="btn">Yes</a>
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
								<span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
						  </div>

    </div>
    );
  }
}
export default withRouter(List);